export const DEAL_NOTE_TYPE = 54
export const ART_NOTE_TYPE = 39
export const DEFAULT_NOTE_TYPE = 10

export const DEFAULT_NOTE_IMAGE_TYPE = 4
export const DEFAULT_IMAGE_USAGE_RIGHT = 1
